import { useState } from 'react';
import axios from 'axios';

const projectID = '5700f478-fcb0-43db-b448-c44e124b1a5b';

const Modal = (props) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const authObject = { 'Project-ID': projectID, 'User-Name': username, 'User-Secret': password };

    try {
      await axios.get('https://api.chatengine.io/chats', { headers: authObject });

      localStorage.setItem('username', username);
      localStorage.setItem('password', password);
      window.location.reload();
      props.logedIn();
      setError('');
    } catch (err) {
      setError('Oops, incorrect credentials.');
    }
  };

  return (
    <div className="wrapper">
      <div className="form">
        <h1 className="title">ඇතුල්වන්න!.</h1>
        <form onSubmit={handleSubmit}>
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="input" placeholder="නම ඇතුළත් කරන්න" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input" placeholder="මුරපදය ඇතුළත් කරන්න" required />
          <div align="center">
            <button type="submit" className="button">
              <span>කතාබස් ආරම්භ කරන්න</span>
            </button>
            <span onClick={props.shift} style={{ cursor: 'pointer', marginTop: "30px" , color: 'white' }} >ලියාපදිංචිවීමට මෙතන ක්ලික් කරන්න</span>< br/>
            <span className="error" >{error}</span>
          </div>
        </form>
      </div>
    </div>

  );
};

export default Modal;